export function copyDivToClipboard(element?: HTMLElement) {
  if (!element) {
    return
  }

  const range = document.createRange()

  range.selectNode(element)
  window.getSelection()?.removeAllRanges() // clear current selection
  window.getSelection()?.addRange(range) // to select text
  document.execCommand('copy')
  window.getSelection()?.removeAllRanges() // to deselect
}

export async function copyContentToClipboard(content: Record<string, string>) {
  const contentBlob = Object.keys(content).reduce(
    (acc, type) => {
      acc[type] = new Blob([content[type]], { type: type })
      return acc
    },
    {} as Record<string, Blob>,
  )

  await navigator.clipboard.write([new ClipboardItem(contentBlob)])
}
